import React from 'react'
import { Message } from 'semantic-ui-react'
import 'semantic-ui-css/components/message.css'

export default class ErrorBoundary extends React.Component {
  state = { error: null }

  componentDidCatch(error, info) {
    this.setState({ error: error.toString().replace('Error: ', '') })
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, info);
  }

  render() {
    const { error } = this.state

    if (error)
      return (
        <Message negative>
          <Message.Header>Error</Message.Header>
          <p>{error}</p>
        </Message>
      )
    return this.props.children
  }
}
